import { useTranslation } from 'react-i18next';

// Create a function to return the translated navigation items
export const getNavigation = (t: Function, isLarge: boolean) => [
  {
    text: t('home'),  // Use translation key
    path: '/home',
    icon: 'home',
    expanded: true 
  },
  {
    text: t('clienti'),
    path: '/customers',
    icon: 'group',
    expanded: true 
  },
  {
    text: t('ordini'),
    icon: 'ordersbox',
    expanded: true ,
    items: [
      {
        text: t('bozze'),
        path: '/orders/bozze'
      },
      {
        text: t('chiusi'),
        path: '/orders/chiusi'
      },
      {
        text: t('storico'),
        path: '/orders/storico'
      }
    ]
  }
  // Add more navigation items if necessary
];